var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsBoolean, IsDateString, IsNumber, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { InvoiceLineResponseDto } from './invoice-line.response.dto.js';
export class InvoiceResponseDto {
    id;
    createdAt;
    updatedAt;
    effectiveAt;
    invoiceNumber;
    stripeId;
    rawData;
    dueDate;
    total;
    pdfLink;
    userId;
    officeId;
    officeLocationId;
    lines;
    isPaid;
    connectedStripeAccountId;
    stripeAccountId;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], InvoiceResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], InvoiceResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], InvoiceResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceResponseDto.prototype, "effectiveAt", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceResponseDto.prototype, "invoiceNumber", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], InvoiceResponseDto.prototype, "stripeId", void 0);
__decorate([
    IsString(),
    Exclude(),
    __metadata("design:type", String)
], InvoiceResponseDto.prototype, "rawData", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceResponseDto.prototype, "dueDate", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], InvoiceResponseDto.prototype, "total", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], InvoiceResponseDto.prototype, "pdfLink", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceResponseDto.prototype, "userId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceResponseDto.prototype, "officeId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    Type(() => InvoiceLineResponseDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], InvoiceResponseDto.prototype, "lines", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], InvoiceResponseDto.prototype, "isPaid", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceResponseDto.prototype, "connectedStripeAccountId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceResponseDto.prototype, "stripeAccountId", void 0);
//# sourceMappingURL=invoice.response.dto.js.map